<template>
    <div class="k-table k-table--actions" :class="skinName">
        <table v-if="actions.length > 0" cellspacing="0">
            <tr>
                <th class="fst">序号</th>
                <th>股票名称</th>
                <th>实际涨幅度</th>
                <th>我的预测</th>
                <th class="lst">得分</th>
            </tr>
            <router-link tag="tr" v-for="(item, index) in actions" :key="item.kid" :to="to(item)">
                <td>{{index + 1}}</td>
                <td>*****</td>
                <td v-if="hasResult">
                    <k-num-rate :value="+item.realPer" />
                </td>
                <td v-else>--</td>
                <td>
                    <k-num-rate :value="+item.predictPer" />
                </td>
                <td v-if="hasResult">{{item.gameScore}}</td>
                <td v-else>--</td>
            </router-link>
        </table>
        <div v-else class="no-data">
            <p>暂无记录<br><br></p>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'k-table-actions',
        props: ['actions', 'skin'],
        computed: {
            ...mapGetters(['isAfter', 'finalRes']),
            hasResult() {
                return this.isAfter(this.finalRes)
            },
            skinName() {
                return this.skin ? `skin-${this.skin}` : 'skin-match'
            }
        },
        methods: {
            to(action) {
                return `/reality/play/${action.cupId}/${action.gameId}/${action.kid}`
            }
        }
    };

</script>
